export default {
  methods: {
    hasSlotName (slotName) {
      return !!this.$slots[slotName] || !!this.$scopedSlots[slotName];
    },
  },
};
